(function () {
  'use strict';
  if (customElements.get('leha-cart-confirmation')) return;
  function current() { return document.querySelector('leha-cart-confirmation'); }
  function total(amount, quantity, precision) {
    if (!/^\d+(\.\d+)?$/.test(String(amount)) || !Number.isSafeInteger(quantity) || quantity < 1 || ![0,2,3].includes(precision)) throw Error('price_format');
    var parts = String(amount).split('.');
    if ((parts[1] || '').length > precision) throw Error('price_precision');
    var minor = BigInt(parts[0] + (parts[1] || '').padEnd(precision, '0')) * BigInt(quantity);
    var digits = String(minor).padStart(precision + 1, '0');
    return precision ? (digits.slice(0,-precision) + '.' + digits.slice(-precision)).replace(/\.?0+$/, '') : digits;
  }
  window.LehaCartConfirmation = {
    open:function (reply, context) { return current()?.open(reply, context); },
    close:function () { current()?.close(); },
    error:function (message) {
      var node = current()?.querySelector('[data-confirm-error]');
      if (node) { node.textContent = message || current().dataset.confirmFailed; node.hidden = false; }
    }
  };
  customElements.define('leha-cart-confirmation', class extends HTMLElement {
    connectedCallback() {
      this.dispose();
      this.events = new AbortController();
      this.dialog = this.querySelector('dialog');
      if (!this.dialog) return;
      var signal = this.events.signal;
      this.addEventListener('click', event => {
        if (event.target.closest('[data-confirm-close]')) this.close();
        if (event.target === this.dialog) {
          var rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
        }
      }, {signal});
      this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); }, {signal});
      this.dialog.addEventListener('close', () => this.restore(), {signal});
      this.addEventListener('keydown', event => {
        if (!this.dialog.open) return;
        if (event.key === 'Escape') { event.preventDefault(); this.close(); }
        if (event.key !== 'Tab') return;
        var controls = Array.from(this.dialog.querySelectorAll('button,a[href],input')).filter(node => !node.disabled && !node.hidden);
        var first = controls[0], last = controls.at(-1);
        if (event.shiftKey && (document.activeElement === first || document.activeElement === this.dialog)) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }, {signal});
    }
    lock() {
      if (this.locked) return;
      this.locked = true;
      this.position = {x:window.scrollX,y:window.scrollY};
      this.saved = new Map();
      var gutter = Math.max(0,window.innerWidth-document.documentElement.clientWidth);
      var changes = [[document.documentElement,'overflow','hidden'],[document.body,'position','fixed'],[document.body,'top',-this.position.y+'px'],[document.body,'left',-this.position.x+'px'],[document.body,'right','0'],[document.body,'inline-size','100%'],[document.body,'padding-inline-end',(parseFloat(getComputedStyle(document.body).paddingInlineEnd)||0)+gutter+'px']];
      changes.forEach(([node,property,value]) => { this.saved.set(node.tagName+property,{node,property,value:node.style.getPropertyValue(property),priority:node.style.getPropertyPriority(property)}); node.style.setProperty(property,value); });
    }
    restore() {
      this.generation = (this.generation || 0) + 1;
      this.request?.abort();
      clearTimeout(this.deadline);
      if (!this.locked) return;
      this.locked = false;
      this.saved.forEach(({node,property,value,priority}) => { if (value) node.style.setProperty(property,value,priority); else node.style.removeProperty(property); });
      this.background?.forEach(([node,inert]) => { node.inert = inert; });
      this.background = null;
      this.removeAttribute('data-confirm-fallback');
      window.scrollTo({left:this.position.x,top:this.position.y,behavior:'instant'});
      if (this.opener?.isConnected) this.opener.focus({preventScroll:true});
      this.dialog.classList.remove('active');
    }
    close() {
      if (this.dialog?.open) {
        if (this.dialog.close) this.dialog.close(); else this.dialog.removeAttribute('open');
      }
      this.restore();
    }
    open(reply, context) {
      if (!this.dialog || !this.isConnected) return;
      this.request?.abort();
      clearTimeout(this.deadline);
      var generation = this.generation = (this.generation || 0) + 1;
      this.opener = context.opener?.isConnected ? context.opener : document.activeElement;
      this.context = context;
      var item = reply.items?.find(item => String(item.variant_id || item.id) === context.variantId) || reply;
      this.key = item.key || '';
      this.querySelector('[data-confirm-error]').hidden = true;
      this.querySelector('[data-confirm-title]').textContent = (context.label || item.product_title || item.title || '').slice(0,80);
      this.querySelector('[data-confirm-quantity]').textContent = this.dataset.confirmQuantity.replace('__COUNT__',String(context.quantity));
      this.priceUnavailable(this.dataset.confirmChecking);
      var image = this.querySelector('[data-confirm-image]');
      image.hidden = true;
      var source = item.image || item.featured_image?.url;
      if (source) { image.src = source; image.hidden = false; }
      this.lock();
      if (!this.dialog.open) {
        if (this.dialog.showModal) this.dialog.showModal();
        else {
          this.setAttribute('data-confirm-fallback','');
          this.background = Array.from(document.body.children).filter(node => !node.contains(this)).map(node => [node,node.inert]);
          this.background.forEach(([node]) => { node.inert = true; });
          this.dialog.setAttribute('open','');
        }
      }
      this.dialog.classList.add('active');
      this.querySelector('[data-confirm-close]').focus({preventScroll:true});
      this.refresh(generation);
    }
    priceUnavailable(text) {
      this.querySelector('[data-confirm-unit]').textContent = text || this.dataset.confirmUnavailable;
      this.querySelector('[data-confirm-total]').textContent = text || this.dataset.confirmUnavailable;
    }
    async refresh(generation) {
      var controller = this.request = new AbortController();
      var started = performance.now();
      this.deadline = setTimeout(() => { controller.abort(); if (this.generation === generation) this.priceUnavailable(); },10000);
      try {
        var url = new URL(window.routes.cart_url,window.location.href);
        for (var key of ['preview_theme_id','preview_key','_fd','_sc','country','currency']) {
          var value = new URL(window.location.href).searchParams.get(key);
          if (value !== null) url.searchParams.set(key,value);
        }
        url.searchParams.set('section_id',this.dataset.confirmSection);
        url.searchParams.set('_leha_refresh',String(Date.now()));
        var response = await fetch(url.href,{credentials:'same-origin',cache:'no-store',signal:controller.signal});
        if (!response.ok) throw Error('cart_section');
        var doc = new DOMParser().parseFromString(await response.text(),'text/html');
        if (this.generation !== generation || !this.dialog.open || !this.isConnected) return;
        var candidates = Array.from(doc.querySelectorAll('[data-confirm-line]')).filter(line => line.dataset.confirmVariant === this.context.variantId);
        var line = this.key ? candidates.find(line => line.dataset.confirmKey === this.key) : candidates.length === 1 ? candidates[0] : null;
        if (!line) throw Error('cart_line_missing');
        var picture = line.querySelector('img'), target = this.querySelector('[data-confirm-image]');
        if (picture) { target.src = picture.src; target.alt = picture.alt; target.hidden = false; }
        if (!this.context.label) this.querySelector('[data-confirm-title]').textContent = line.querySelector('[data-confirm-name]').textContent;
        var state = JSON.parse(line.querySelector('[data-confirm-state]').textContent);
        var html = line.querySelector('[data-confirm-price]').innerHTML;
        var snapshot = this.context.summary;
        if (snapshot) {
          if (snapshot.variantId !== this.context.variantId || line.dataset.confirmCountry !== snapshot.country ||
              line.dataset.confirmSnapshotCountry !== snapshot.country || line.dataset.confirmSnapshotCurrency !== snapshot.currency ||
              Number(line.dataset.confirmSnapshotPrice) !== Number(snapshot.unitPrice)) throw Error('cart_snapshot_mismatch');
          state = snapshot.state;
          html = snapshot.priceHtml;
        } else {
          window.LehaCommercialPricing.responseLease(state,this.context.variantId,line.dataset.confirmCountry,response.headers,performance.now()-started);
        }
        if (state.status !== 'resolved') throw Error('price_unavailable');
        var holder = document.createElement('div'); holder.innerHTML = html;
        var money = holder.querySelector('.leha-money');
        if (!money || money.querySelector('.leha-money__code').textContent.trim() !== state.currency_code ||
            Number(money.querySelector('.leha-money__amount').textContent) !== Number(state.effective_price)) throw Error('price_display_mismatch');
        this.querySelector('[data-confirm-unit]').replaceChildren(money.cloneNode(true));
        var sum = money.cloneNode(true);
        sum.querySelector('.leha-money__amount').textContent = total(state.effective_price,this.context.quantity,Number(state.currency_precision));
        this.querySelector('[data-confirm-total]').replaceChildren(sum);
      } catch (error) {
        if (this.generation === generation && this.isConnected && this.dialog.open) this.priceUnavailable();
      } finally { if (this.generation === generation) clearTimeout(this.deadline); }
    }
    dispose() {
      this.close();
      this.events?.abort();
      this.request?.abort();
      clearTimeout(this.deadline);
    }
    disconnectedCallback() { this.dispose(); }
  });
})();
